import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-exam-master',
  templateUrl: './exam-master.component.html',
  styleUrls: ['./exam-master.component.scss']
})
export class ExamMasterComponent implements OnInit {
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  APIService: any;
  ExamMasterForm: FormGroup;
  examDataSearchForm: FormGroup;
  examList: any;
  list;
  autoserialnumber;
  dropdowndisable = false;
  desLabel: any;
  CourseList: any;
  filteredListCourse: any;
  markList: any;
  filteredListOfMark: any;
  dialogRef: MatDialogRef<any>;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router,
    private route: ActivatedRoute,
    private httpClient: HttpClient,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.dropdowndisable = false;
    this.submitButton = true;
    this.editButton = false;
  
    this.ExamMasterForm = this.fb.group({
       EmId : new FormControl('0'),
       EmCoCode : new FormControl(''),
       EmSrNo : new FormControl(this.autoserialnumber),
       EmCode : new FormControl(''),
       EmName : new FormControl(''),
       EmShName : new FormControl(''),
       EmStreams : new FormControl(''),
       EmClrSrNo : new FormControl(''),
       EmATKTSub : new FormControl(''),
       EmElgblCd : new FormControl(''),
       EmLedger : new FormControl(''),
       EmMarkList : new FormControl(''),
       EmLatEntry : new FormControl(''),
       EmRejImpr : new FormControl(''),
       EmEval : new FormControl(''),
       EmTotSub : new FormControl(''),
       EmMaxTot : new FormControl(''),
       EmPassPC : new FormControl(''),
       EmVal : new FormControl(''),
       EmValDev : new FormControl(''),
       EmDiv : new FormControl(''),
       EmConv : new FormControl(''),
       EmDivFirstAtt : new FormControl(''),
       EmDivFirstMrk : new FormControl(''),
       EmCompart : new FormControl(''),
       EmColg : new FormControl(''),
       EmGrps : new FormControl(''),
       EmSubTot : new FormControl(''),
       EmMinCr : new FormControl(''),
       EmMaxCr : new FormControl(''),
       EmExmSuppl : new FormControl(''),
       EmExmQ : new FormControl(''),
       EmMarksD : new FormControl(''),
       EmDebar : new FormControl(''),
       EmDebarNo : new FormControl(''),
       EmDebarType : new FormControl('')


    }),
    this.fetchCourseCode();
    this.getExamAllData();
    this.fetchMarklist();
      this.examDataSearchForm = this.fb.group({
        SearchString: new FormControl(''),
      })
  }
  keypress() {
    this.umsService.getExam(this.examDataSearchForm.value).subscribe(res => {
      this.examList = res.data;
    }, (ERROR: HttpErrorResponse) => {
      this.examList = [];
    });
  }

  download() {
    const wwe = ['EmId', 'EmCoCode', 'EmSrNo', 'EmCode', 'EmName', 'EmShName', 'EmStreams', 'EmClrSrNo', 'EmATKTSub',
      'EmElgblCd', 'EmLedger', 'EmMarkList', 'EmLatEntry', 'EmRejImpr', 'EmEval', 'EmTotSub', 'EmMaxTot', 'EmPassPC',
      'EmVal', 'EmValDev', 'EmDiv', 'EmConv', 'EmDivFirstAtt', 'EmDivFirstMrk', 'CoName', 'EmSpFlag', 'EmColg',
      'EmGrps', 'EmSubTot', 'EmMinCr', 'EmMaxCr', 'EmExmSuppl', 'EmExmQ', 'EmMarksD', 'EmDebar', 'EmDebarNo', 'EmDebarType'];
    this.umsService.downloadFile(this.examList, 'jsontocsv', wwe);
  }

  selectCourseNoPopulation(e, course) {
    if (e === 'true') {
      this.list = false;
      this.getExamDataNoPrepoluation(course.CoCode)
      this.dropdowndisable = true;
      // this.getExamData();
      // this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  getExamDataNoPrepoluation(e) {
    const payload = {};
    payload['EmCoCode'] = e
    this.examList = [];
    this.umsService.getExam(payload).subscribe(res => {
      this.examList = res.data;
      this.autoserialnumber = this.examList.length + 1;
      this.ExamMasterForm.patchValue({
        EmSrNo: this.autoserialnumber,
      });
    }, (ERROR: HttpErrorResponse) => {
      this.ExamMasterForm.patchValue({
        EmSrNo: 1
      });
    });
  }
  codeTypeClick(value)
  {
   this.desLabel = value;
  }
  fetchCourseCode() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.ExamMasterForm = this.fb.group({
        EmId : new FormControl('0'),
        EmCoCode : new FormControl(''),
        EmSrNo : new FormControl(this.autoserialnumber),
        EmCode : new FormControl(''),
        EmName : new FormControl(''),
        EmShName : new FormControl(''),
        EmStreams : new FormControl(''),
        EmClrSrNo : new FormControl(''),
        EmATKTSub : new FormControl(''),
        EmElgblCd : new FormControl(''),
        EmLedger : new FormControl(''),
        EmMarkList : new FormControl(''),
        EmLatEntry : new FormControl(''),
        EmRejImpr : new FormControl(''),
        EmEval : new FormControl(''),
        EmTotSub : new FormControl(''),
        EmMaxTot : new FormControl(''),
        EmPassPC : new FormControl(''),
        EmVal : new FormControl(''),
        EmValDev : new FormControl(''),
        EmDiv : new FormControl(''),
        EmConv : new FormControl(''),
        EmDivFirstAtt : new FormControl(''),
        EmDivFirstMrk : new FormControl(''),
        EmCompart : new FormControl(''),
        EmColg : new FormControl(''),
        EmGrps : new FormControl(''),
        EmSubTot : new FormControl(''),
        EmMinCr : new FormControl(''),
        EmMaxCr : new FormControl(''),
        EmExmSuppl : new FormControl(''),
        EmExmQ : new FormControl(''),
        EmMarksD : new FormControl(''),
        EmDebar : new FormControl(''),
        EmDebarNo : new FormControl(''),
        EmDebarType : new FormControl('')
      });
      this.fetchCourseCode();
      this.examList = [];
      this.dropdowndisable = false;
      this.submitButton = true;
      this.editButton = false;
    } else {
      this.list = true;
      this.fetchCourseCode();
      this.dropdowndisable = false;
      this.getExamAllData();
    }
  }

  getExamAllData() {
    const payload = {};
    this.umsService.getExam(payload).subscribe(res => {
      this.examList = res.data;
      // this.dataSource = new MatTableDataSource(this.facultyList);
    });
  }

  fetchMarklist() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.markList = res.data;
        this.filteredListOfMark = this.markList.slice();
      } else {
        // this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  submit() {
    if (this.ExamMasterForm.invalid) {
      // this.ExamMasterForm.get('EmId').markAsTouched();
      // this.ExamMasterForm.get('EmCoCode').markAsTouched();
      // this.ExamMasterForm.get('EmSrNo').markAsTouched();
      // this.ExamMasterForm.get('EmCode').markAsTouched();
      // this.ExamMasterForm.get('EmName').markAsTouched();
      // this.ExamMasterForm.get('EmShName').markAsTouched();
      // this.ExamMasterForm.get('EmStreams').markAsTouched();
      // this.ExamMasterForm.get('EmClrSrNo').markAsTouched();
      // this.ExamMasterForm.get('EmATKTSub').markAsTouched();
      // this.ExamMasterForm.get('EmElgblCd').markAsTouched();
      // this.ExamMasterForm.get('EmLedger').markAsTouched();
      // this.ExamMasterForm.get('EmMarkList').markAsTouched();
      // this.ExamMasterForm.get('EmLatEntry').markAsTouched();
      // this.ExamMasterForm.get('EmRejImpr').markAsTouched();
      // this.ExamMasterForm.get('EmEval').markAsTouched();
      // this.ExamMasterForm.get('EmTotSub').markAsTouched();
      // this.ExamMasterForm.get('EmMaxTot').markAsTouched();
      // this.ExamMasterForm.get('EmPassPC').markAsTouched();
      // this.ExamMasterForm.get('EmVal').markAsTouched();
      // this.ExamMasterForm.get('EmValDev').markAsTouched();
      // this.ExamMasterForm.get('EmDiv').markAsTouched();
      // this.ExamMasterForm.get('EmConv').markAsTouched();
      // this.ExamMasterForm.get('EmDivFirstAtt').markAsTouched();
      // this.ExamMasterForm.get('EmDivFirstMrk').markAsTouched();
      // this.ExamMasterForm.get('EmCompart').markAsTouched();
      // this.ExamMasterForm.get('EmColg').markAsTouched();
      // this.ExamMasterForm.get('EmGrps').markAsTouched();
      // this.ExamMasterForm.get('EmSubTot').markAsTouched();
      // this.ExamMasterForm.get('EmMinCr').markAsTouched();
      // this.ExamMasterForm.get('EmMaxCr').markAsTouched();
      // this.ExamMasterForm.get('EmExmSuppl').markAsTouched();
   //   this.ExamMasterForm.get('EmExmQ').markAsTouched();
      // this.ExamMasterForm.get('EmMarksD').markAsTouched();
      // this.ExamMasterForm.get('EmDebar').markAsTouched();
    //  this.ExamMasterForm.get('EmDebarNo').markAsTouched();
      // this.ExamMasterForm.get('EmDebarType').markAsTouched();
      return;
    } else {
      this.Exam();
    }
  }

  Exam() {
    let submitpayload = this.ExamMasterForm.value;
    this.umsService.addExam(submitpayload).subscribe(res => {
      if (res.status) {
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      } else {
        let data = {};
        data['message'] = res.message;    
        data['title'] = 'Information';    
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      }
    });
  }
}
